export function getFromLocalStorage(key: string): any {
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key) as string) : null;
}

export function setToLocalStorage(key: string, value: any): void {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e: unknown) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to write "${key}" to localStorage:`, e);
    }
}